<template>
  <div class="graph-container">
      <div class="graph-header">
        <h5>{{ title }} ({{currentDayZoom}} derniers jours)</h5>
        <span v-if="isLoading || isUpdating">
          <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        </span>
      </div>
      <div v-if="!isLoading" style="width: 100%">
      <apexchart
          type="area"
          :options="generateDefaultChartOptions(colors, formatter)"
          :series="data"
          height="500"
      ></apexchart>
      </div>
  </div>
</template>

<script>

export default {
  name: 'DocumentStatGraph',
  props: ['title', 'data', 'isLoading', 'isUpdating', 'colors', 'formatter', 'updateData'],
  data() {
    return {
      maxDayZoom: 7,
      currentDayZoom: 30,
      zoomActionDebouncer: [],
    }
  },
  methods: {
    zoomed: function(chartContext, { xaxis }) {
      let focusedDayCount = 30
      var d = new Date(0)
      d.setTime(xaxis.min)
      var start = Math.floor(new Date().getTime() / (3600 * 24 * 1000))
      var end = Math.floor(d.getTime() / (3600 * 24 * 1000))
      var diff = start - end

      if(!Number.isNaN(diff))
        focusedDayCount = diff + 1
      this.zoomActionDebouncer.push(focusedDayCount)
      setTimeout(() => {
        let last = this.zoomActionDebouncer.shift()

        if(this.zoomActionDebouncer.length != 0)
          return;
        this.currentDayZoom = last
        if(last > this.maxDayZoom) {
          console.log(`Fetching data -> days:${last - this.maxDayZoom} offset-${this.maxDayZoom}`)
          this.updateData(last - this.maxDayZoom, this.maxDayZoom)
          // this.maxDayZoom = last
        }
      }, 500)

    },
    generateDefaultChartOptions (colorArray, formatter = (v) => v.toFixed(1), zoomed = this.zoomed) {
      return {
        chart: {
          height: 500,
          width: '100%',
          type: 'area',
          events: {
            beforeZoom: function(chartContext, { xaxis }) {
              return {
                xaxis: {
                  max: xaxis.max > Date.now() ? Date.now() : xaxis.max,
                  min: xaxis.min
                }
              }
            },
            zoomed
          },
          zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: false,
          }
        },
        colors: colorArray,
        dataLabels: {
          enabledOncountAverageSerie: undefined,
          formatter,
          enabled: true,
          background: {
            borderWidth: 0,
            padding: 10,
            borderRadius: 10,
          },
        },
        grid: {
            padding: {
              left: 50,
              right: 60
            }
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 'dataPoints'
        },
        yaxis: {
          labels: {
            formatter
          },
          min: 0
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy'
          }
        },
        legend: {
          offsetY: 5,
        }
      }
    },
  }
}
</script>


<style type="css" scoped>
.graph-container {
  margin: 0;
  padding: 0;
  min-height: 100px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

.graph-header {
  position: relative;
  padding: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.graph-header > span {
  position: absolute;
  left: 0.5em;
  top: 0.5em;
}

</style>



// WEBPACK FOOTER //
// src/components/graph/BoardDocumentStatGraph.vue